import {APIService} from '@/services/api.service';

export async function validateToken(): Promise<boolean> {
  try {
    await APIService.get(`verify`, {}, true, true);
    return true;
  } catch (e) {
    return false;
  }
}
